export default "__VITE_ASSET__DxyGm50X__"